import { Box, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Text, VStack } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { AccountContext } from 'components/AccountContext';
import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import useViewModalNotificacao from './useViewModalNotificacao';
import {  IoMdClose } from 'react-icons/io';

function ModalNotificacao(props) {
  const disclosure = props.disclosure;
  const notificacoes = props.cacheNotificacao;
  const refetch = props.refetch;
  const { user } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));

  const { handleReadNotification } = useViewModalNotificacao({ refetch });
  
  return (
      <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose} isCentered>
        <ModalOverlay />
        <ModalContent maxW="90%" h="auto" borderRadius="0.8em" p={4}>
        <ModalCloseButton />
          <ModalBody width={'100%'} p={0} m={0}>
            <VStack width={'100%'} spacing={4} p={0} m={0}>
              <Text color={theme.color} fontWeight="bold" fontSize="2xl" textAlign="center">
                Notificações
              </Text>
              <VStack spacing={2} w="100%" maxHeight={'70dvh'} overflowY={'scroll'}>
                {notificacoes.length == 0 && <Text color={'gray.400'} fontWeight="bold" fontSize="lg" textAlign="center">
                  Sem notificações
                </Text>}
                {notificacoes.map((notificacao) => {
                  return (
                    <VStack key={`${notificacao.id}`} position={'relative'} border={`1px solid ${theme.background}`} width={'100%'} align={'left'} p={4} borderRadius={'0.8em'} >
                      <Box position={'absolute'} top={5} right={5} >
                        <IoMdClose color={theme.color} boxSize="1.5em" onClick={()=>handleReadNotification(notificacao.id)} />
                      </Box>
                      <Text><Text color={theme.color} fontSize="sm" fontWeight="bold">Paciente:</Text>{notificacao.p_nome}</Text>
                      <Text><Text color={theme.color} fontSize="sm" fontWeight="bold">Procedimento:</Text>{notificacao.pt_nome}</Text>
                      <Text>{notificacao.message}</Text>
                    </VStack>
                  );
                })}
              </VStack>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
  );
}

export default ModalNotificacao;
